import { findAll } from '@ui/helpers/string';
import { htmlToTiptapText } from './htmlToTiptapText';

export const getTiptapTextRange = ({ html, lookupText = '', occurrence }) => {
  if (lookupText === null) {
    return { from: 1, to: 1 };
  }

  const text = htmlToTiptapText(html);
  const positions = findAll(text, lookupText);
  const position = positions[occurrence];

  if (position === undefined) {
    return { from: 0, to: 0 };
  }

  return {
    from: position + 1,
    to: position + 1 + lookupText.length,
    charBefore: text.charAt(position - 1),
    charAfter: text.charAt(position + lookupText.length),
  };
};
